import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

// Create the context
const CommonDataContext = createContext();

// Create a provider component
export const CommonDataProvider = ({ children }) => {
  const [stokistData, setStokistData] = useState([]);
  const [versionData, setVersionData] = useState(null);
  const [availableYears, setAvailableYears] = useState([]);
  const [productData, setProductData] = useState([]);
  const [sortedProductData, setSortedProductData] = useState([]);
  const [campaignData, setCampaignData] = useState([]);
  const [repData, setRepData] = useState([]);
  const [docData, setDocData] = useState([]);
  const [hqData, setHqData] = useState([]);
  const [locationSectorData, setLocationSectorData] = useState([]);
  const [totalStokist, setTotalStokist] = useState(0);
  const [totalProducts, setTotalProducts] = useState(0);
  const [totalReps, setTotalReps] = useState(0);
  const [totalDoctors, setTotalDoctors] = useState(0);

  const fetchData = async (url, token) => {
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`, // Replace 'YOUR_ACCESS_TOKEN' with your actual access token
        },
      });
      return response.data;
    } catch (error) {
      if (error.response.status === 404) {
        return [];
      }
      console.error(`Error fetching data from ${url}:`, error);
      return [];
    }
  };

  const fetchMultipleApis = async (urls) => {
    const userDetails = JSON.parse(localStorage.getItem("token"));
    let token = userDetails ? userDetails.result.token : null;
    const promises = urls.map((url) => fetchData(url, token));
    return Promise.all(promises);
  };

  const [apiData, setApiData] = useState(null);
  useEffect(() => {
    // console.log("state apidata", apiData);
  }, [apiData]);

  const dataFetch = async (searchQuery) => {
    const fetchDataAndStore = async () => {
      // console.log("enterd data fetch")
      const apiUrls = [
        `${process.env.REACT_APP_SERVER_BASE_URL}/stokists/completelist`,
        `${process.env.REACT_APP_SERVER_BASE_URL}/products/completelist`,
        `${process.env.REACT_APP_SERVER_BASE_URL}/representatives/search?active=true`,
        `${process.env.REACT_APP_SERVER_BASE_URL}/doctors/summary?count=all`,
        `${process.env.REACT_APP_SERVER_BASE_URL}/campaigns`,
        // `${process.env.REACT_APP_SERVER_BASE_URL}/products/completeSortedlist`,
        `${process.env.REACT_APP_SERVER_BASE_URL}/products/completeSortedlist`,
        `${process.env.REACT_APP_SERVER_BASE_URL}/stokists/versionslist`,
        `${process.env.REACT_APP_SERVER_BASE_URL}/headquarters/completelist`,
        `${process.env.REACT_APP_SERVER_BASE_URL}/doctors/locations-sectors`,
        `${process.env.REACT_APP_SERVER_BASE_URL}/doctors/completeList`,
      ];

      try {
        const data = await fetchMultipleApis(apiUrls);
        const newData = {};
        apiUrls.forEach((url, index) => {
          newData[index] = data[index] ? data[index] : [];
        });
        // console.log('from common data provider',newData)
        setApiData(newData);

        setStokistData(newData[0]);
        setTotalStokist(newData[0].length);

        setProductData(newData[1]);
        setTotalProducts(newData[1].length);

        setSortedProductData(newData[5]);

        const allReps = newData[2] || [];

        // Fetch visible reps for hierarchy roles (RBM/ABM/REPRESENTATIVE)
        try {
          const userDetails = JSON.parse(localStorage.getItem("token"));
          const token = userDetails ? userDetails.result.token : null;
          const visRes = await fetchData(
            `${process.env.REACT_APP_SERVER_BASE_URL}/users/me/visible-reps`,
            token
          );
          const visibleReps = visRes && visRes.visibleReps;
          if (Array.isArray(visibleReps)) {
            // Restrict dropdown to only reps this user can see
            const filtered = allReps.filter(r => visibleReps.includes(r.name));
            setRepData(filtered);
            setTotalReps(filtered.length);
          } else {
            // null = no restriction (ADMIN/SUPER_USER/REGULAR_USER)
            setRepData(allReps);
            setTotalReps(allReps.length);
          }
        } catch (e) {
          setRepData(allReps);
          setTotalReps(allReps.length);
        }

        setDocData(newData[9]);
        setTotalDoctors(newData[9].length);
        
        setCampaignData(newData[4]?newData[4].data:[]);
        setVersionData(newData[6] ? newData[6] : []);
        setHqData(newData[7] ?? []);
        setLocationSectorData(newData[8] ?? []);

        // Fetch available years from transaction reports
        try {
          const userDetails = JSON.parse(localStorage.getItem("token"));
          const token = userDetails ? userDetails.result.token : null;
          const yearsRes = await fetchData(
            `${process.env.REACT_APP_SERVER_BASE_URL}/transactionreports/availableyears`,
            token
          );
          if (Array.isArray(yearsRes)) {
            setAvailableYears(yearsRes.map((y) => ({ label: String(y), value: y })));
          }
        } catch (e) {
          console.error("Error fetching available years:", e);
        }
        // console.log('$$$$$$$$$$$$$$$$$$$$$$$$$$',newData[7])

        // localStorage.setItem('monthData',JSON.stringify(newData))
        // console.log("data from context:",newData)
      } catch (error) {
        console.error("Error fetching data from APIs:", error);
      }
    };
    fetchDataAndStore();
  };
  useEffect(() => {
    dataFetch();
  }, []);

  return (
    <CommonDataContext.Provider
      value={{
        stokistData: stokistData,
        repData,
        productData,
        sortedProductData,
        docData,
        dataFetch,
        totalStokist: totalStokist,
        totalProducts,
        totalReps,
        totalDoctors,
        campaignData,
        versionData: versionData,
        hqData,
        locationSectorData,
        availableYears,
      }}
    >
      {children}
    </CommonDataContext.Provider>
  );
};

export const useCommonDataContext = () => {
  return useContext(CommonDataContext);
};
